import * as React from "react";
import { quoteSteppersMap } from "../../Resource/Content";
import { IProcessComponentProps, ProcessComponent } from "../../../../../../Shared/Process/Process/ProcessComponent";
import { SectionHeader, TrueFalseRadio } from "../../../NewBusinessWizard/Components/SharedComponents";
import { SubAccountType } from "../../../../../../../Wrap/Constants/Enums/Domain/SubAccountType";
import { CheckboxGroup } from "../../../../../../Shared/CheckboxGroup/CheckboxGroup";
import { ProductWrapper } from "../../../../../../../Wrap/Models/Domains/Account/ProductWrapper";
import { ProductWrapperStore } from "../../Store/Variable";
import { NewQuoteAction } from "../../Actions/NewQuoteAction";
import { getQueryParameters } from "../../../../../../Shared/Wizards/Entities/QueryParametersHelper";
import { SIPPSection } from "./SIPPSection";
import { JSIPPSection } from "./JSIPPSection";
import { PartLoading } from "../../../../../../../react-core/Html/PartLoading";
import { TextBoxEditor } from "../../../../../../../react-core/Html/TextBoxEditor";
import { ISASection } from "./ISASection";
import { PPSection } from "./PPSection";
import { NewClientAlertMessage } from "../../../Common/WrapperSelection/NewClientAlertMessage";
import { SubAccountTypeHelper } from "../../../Common/Helpers/SubAccountTypeHelper";
import { ClientAccount } from "../../../../../../../Wrap/Models/Domains/Account/SlAccounts/ClientAccount";
import { ProductDetailsStore } from "../../../../../Stroes/Variable";
import { NewBusinessAction } from "../../../NewBusinessWizard/Actions/NewBusinessAction";
import { AdviserContextStoreStatic, CustomerContextStoreStatic } from "../../../NewBusinessWizard/Stores/Variable";
import { HierarchyIdHelper } from "../../../../../../Shared/Common/HierarchyIdHelper";
import { HierarchyLevelName } from "../../../../../../../Wrap/Constants/Enums/HierarchyLevelName";
import { QuoteAndApplyBaseModel } from "../../../../../../../Wrap/Models/Models/QuoteAndApplyBase/QuoteAndApplyBaseModel";
import { InvestorType } from "../../../../../../../Wrap/Constants/Enums/Domain/InvestorType";
import { TitleMap } from "../../../../../../Shared/Entities/Maps/TitleMap";
import { ServicePropositionSelection } from "../../../Common/ServicePropositionSelection";
import { InstructionStatus } from "../../../../../../../Wrap/Constants/Enums/Domain/InstructionStatus";
import { UserStore } from "../../../../../Stroes/Variable";
import { JsonDateParser } from "../../../../../../../react-core/Utils/JsonDateParser";
import AdviserSiteTagManager from "../../../../../../Shared/Cookies/ChoicesCookie/AdviserSiteTagManager";
import { QuoteModel } from "../../../../../../../Wrap/Models/Models/Processes/Quote/QuoteModel";
import { DPCQuestion } from "../../../Common/Pension/DPCQuestion";
import { PensionType } from "../../../../../../../Wrap/Constants/Enums/Domain/PensionType";

interface IWrapperSelectionProps extends IProcessComponentProps {
    HasExistingSIPP?: boolean;
    ClientAccount?: ClientAccount;
}

interface IWrapperSelectionState {
    ProductWrappers: ProductWrapper[];
    isLoading: boolean;
}

export class WrapperSelection extends ProcessComponent<IWrapperSelectionProps, IWrapperSelectionState> {
    constructor(props: any) {
        super(props);
        this.state = {
            ProductWrappers: null,
            isLoading: true,
        };
        this.subscribeToStore(ProductWrapperStore, () => this.onProductWrapperStoreChange());
        this.subscribeToStore(ProductDetailsStore, () => {});
        this.subscribeToStore(AdviserContextStoreStatic, () => this.onAdviserContextStoreChange());
        this.subscribeToStore(CustomerContextStoreStatic, () => this.onCustomerContextStoreChange());
    }

    private onProductWrapperStoreChange() {
        const data = ProductWrapperStore.getData();
        this.setState({
            isLoading: false,
            ProductWrappers: data,
        });
    }

    private onAdviserContextStoreChange() {
        this.loadAdviserHierarchyIdFromStore();
    }

    private loadAdviserHierarchyIdFromStore() {
        const adviser = AdviserContextStoreStatic.getData();
        if (adviser) {
            this.props.onChange({
                AdviserHierarchyId: { Type: HierarchyLevelName.Advisor, EntityId: adviser.AdvisorId },
            });
        }
    }

    onCustomerContextStoreChange(): void {
        const customer = CustomerContextStoreStatic.getData();

        this.props.onChange({
            ClientDetails: {
                ActorId: customer.ActorId,
                FirstName: customer.PersonalDetails?.GivenName,
                LastName: customer.PersonalDetails?.FamilyName,
                Title: TitleMap.getString(customer.PersonalDetails?.Title),
                Gender: customer.PersonalDetails?.Gender,
                DateOfBirth: customer.PersonalDetails?.DateOfBirth,
            },
        });

        NewBusinessAction.getAdviserDetail(
            HierarchyIdHelper.toHierarchyIdString(HierarchyLevelName.Advisor, customer.ActorOwnerId)
        );

        this.setState({
            isLoading: false,
        });
    }

    componentDidUpdate(prevProps) {
        super.componentDidUpdate(prevProps);
        const newPp = this.props.data.SelectedProducts.find((x) => SubAccountTypeHelper.isPP(x.SubAccountType));
        const prevData = (prevProps as { data: QuoteAndApplyBaseModel }).data;
        const prevSelections = prevData.SelectedProducts;
        if (
            prevData.AccountServiceProposition != this.props.data.AccountServiceProposition &&
            this.props.data.AccountServiceProposition
        ) {
            const actorId = getQueryParameters()["customerid"];
            NewQuoteAction.getProductWrappers(actorId, this.props.data.AccountServiceProposition);
        }
        const prevSecondClientDetails = prevData.SecondClientDetails;
        const prevPp = prevSelections.find((x) => SubAccountTypeHelper.isPP(x.SubAccountType));
        if (!prevPp) {
            return false;
        }
        if (!newPp && prevSecondClientDetails) {
            this.props.onChange({ SecondClientDetails: null });
        } else if (newPp && newPp.InvestorTypeType != prevPp.InvestorTypeType) {
            const data = this.props.data;

            if (data.SecondClientDetails && newPp.InvestorTypeType == InvestorType.Single) {
                data.SecondClientDetails = null;
            }
            this.props.onChange({
                SelectedProducts: data.SelectedProducts,
                SecondClientDetails: data.SecondClientDetails ? data.SecondClientDetails : null,
            });
        }
    }

    private addEvent = new AdviserSiteTagManager().addEvent;

    componentDidMount() {
        super.componentDidMount();
        const clientId = getQueryParameters()["customerid"];
        const { data, onChange } = this.props;
        const id = getQueryParameters()["id"];
        if (clientId) {
            NewBusinessAction.getCustomerData(clientId);
        }
        if (id || data.AccountServiceProposition) {
            NewQuoteAction.getProductWrappers(clientId, data.AccountServiceProposition);
        }

        if (data?.QuoteReference?.HasQuoteReference === undefined) {
            this.onDataChange(onChange, { HasQuoteReference: false }, data, "QuoteReference");
        }

        this.addEvent({
            environment: {
                appType: "web",
                setting: "prod",
                timestamps: JsonDateParser.toJsonDateNoOffset(new Date()).toString(),
            },
            page: {
                pageUrl: window.location.pathname.includes("wrapper-selection")
                    ? window.location.pathname
                    : window.location.pathname + "/wrapper-selection",
                pageTitle: `${document.title} - new quote - wrapper selection`,
            },
            user: {
                loginId: UserStore.getUserInfo()?.ClientId.toString(),
                internal: "yes",
            },
            event: "pageLoaded",
        });
    }

    public isValid(): boolean {
        let isValid = super.isValid();
        isValid = isValid && this.anyProductSelected();
        if (!this.anyProductSelected()) {this.props.showErrorMsgPopUp(["At least one wrapper must be selected."]);}
        return isValid;
    }

    private anyProductSelected(): boolean {
        return this.props.data?.SelectedProducts != null && this.props.data.SelectedProducts.length > 0;
    }

    

    render() {
        if (this.props.data.ClientDetails == null) {return <PartLoading isLoading={true} />;}
        const giaSelected = this.props.data.SelectedProducts.find((x) => SubAccountTypeHelper.isPP(x.SubAccountType));
        const existingOnshoreBond = this.props.ClientAccount?.SubAccounts?.some(
            (x) => x.SubAccountType == SubAccountType.OnshoreBond
        );
        const existingOffshoreBond = this.props.ClientAccount?.SubAccounts?.some(
            (x) => x.SubAccountType == SubAccountType.OffshoreBond
        );
        const {  onChange } = this.props;
        const data: QuoteModel = this.props.data;
        const { ProductWrappers } = this.state;
        const options =
            ProductWrappers != null
                ? ProductWrappers.filter((w) => {
                    const isDisabled =
                        !w.IsAvailable ||
                        this.props.isReview ||
                        (this.props.ClientAccount?.SubAccounts?.some((x) =>
                            SubAccountTypeHelper.isOnPlatformPension(w.Type)
                        ) &&
                            w.Type == SubAccountType.Npr) ||
                        ((data.Status == InstructionStatus.Complete || data.Status == InstructionStatus.Cancelled) &&
                            data.AccountRoleInstructionId > 0 &&
                            giaSelected != null) ||
                        (w.Type == SubAccountType.OnshoreBond && existingOnshoreBond) ||
                        (w.Type == SubAccountType.OffshoreBond && existingOffshoreBond);

                    return (
                        !SubAccountTypeHelper.isUnlistedProduct(w.Type) &&
                        !SubAccountTypeHelper.isOffPlatformPension(w.Type) &&
                        !isDisabled
                    );
                }).map((ele) => {
                    return {
                        label: ele.DisplayName,
                        value: data.SelectedProducts.some((item) => item.SubAccountType == ele.Type),
                        onChange: (v) => {
                            if (v) {
                                const _data = data.SelectedProducts.concat([
                                    { SubAccountType: ele.Type, IsIncomePaymentDetailsSelected: false },
                                ]);
                                onChange({ SelectedProducts: _data });
                            } else {
                                onChange({
                                    SelectedProducts: data.SelectedProducts.filter(
                                        (item) => item.SubAccountType !== ele.Type
                                    ),
                                });
                            }
                        },
                        disabled: 
                            (ele.Type != SubAccountType.Npr && 
                                this.props.data?.SelectedProducts?.find(
                                    (item) => item.SubAccountType === SubAccountType.Npr
                                )?.IsDisqualifyingPensionCredits
                            )
                    };
                  })
                : [];
        return (
            <>
                <div>{<NewClientAlertMessage />}</div>
                <h2 className="mb-20">{quoteSteppersMap.wrapperSelection}</h2>
                {
                    <div className="row">
                        <div className="col-sm-7 col-7 mb-20">
                            <ServicePropositionSelection
                                actorId={data.ClientDetails?.ActorId}
                                selectedPropositionId={data.AccountServiceProposition}
                                onRef={(ref) => this.appendChild(ref)}
                                data={this.props.data}
                                onChange={(changes) => {
                                    this.props.onChange(changes);
                                    this.setState({ isLoading: true });
                                    NewQuoteAction.getProductWrappers(
                                        data.ClientDetails?.ActorId,
                                        changes.AccountServiceProposition
                                    );
                                }}
                                isReview={this.props.isReview}
                                disable={data.ExistingAccountHierarchyId != null}
                            />
                        </div>
                    </div>
                }
                <PartLoading isLoading={this.state.isLoading}>
                    {data.AccountServiceProposition != null && data.AccountServiceProposition != 0 && (
                        <>

                            {SectionHeader("Create quote for")}
                            <div className="row">
                                <div className="col-sm-7 col-7">
                                    <CheckboxGroup srTitle="Create quote for" type="panel" options={options} />
                                </div>
                            </div>
                            <hr className="mt-5 mb-12" />
                            {data.SelectedProducts.some(
                                (ele) => ele.SubAccountType == SubAccountType.InvestmentAccount
                            ) && (
                                <PPSection
                                    onRef={(ref) => this.appendChild(ref)}
                                    data={this.props.data}
                                    ClientAccount={this.props.ClientAccount}
                                    onChange={(changes) => {
                                        this.props.onChange(changes);
                                    }}
                                    isReview={this.props.isReview}
                                    isQuote={true}
                                />
                            )}
                            {data.SelectedProducts.some((ele) => ele.SubAccountType == SubAccountType.StocksIsa) && (
                                <ISASection
                                    onRef={(ref) => this.appendChild(ref)}
                                    data={this.props.data}
                                    onChange={(changes) => {
                                        this.props.onChange(changes);
                                    }}
                                    isReview={this.props.isReview}
                                />
                            )}
                            {data.SelectedProducts.some((ele) => ele.SubAccountType == SubAccountType.JuniorSipp) && (
                                <JSIPPSection
                                    onRef={(ref) => this.appendChild(ref)}
                                    data={this.props.data}
                                    isReview={this.props.isReview}
                                    onChange={(changes) => {
                                        this.props.onChange(changes);
                                    }}
                                />
                            )}
                            {data.SelectedProducts.some((ele) =>
                                SubAccountTypeHelper.isOnPlatformPension(ele.SubAccountType, true)
                            ) && (
                                <SIPPSection
                                    onRef={(ref) => this.appendChild(ref)}
                                    data={this.props.data}
                                    HasExistingSIPP={this.props.HasExistingSIPP}
                                    subAccountId={
                                        this.props.ClientAccount?.SubAccounts?.find(
                                            (x) =>
                                                x.SubAccountType == SubAccountType.Pension ||
                                                x.SubAccountType == SubAccountType.Sipp ||
                                                x.SubAccountType == SubAccountType.Npr ||
                                                x.SubAccountType == SubAccountType.Pr
                                        )?.ClAccountId
                                    }
                                    isReview={this.props.isReview}
                                    subAccountHierarchyId={
                                        this.props.ClientAccount?.SubAccounts?.find(
                                            (x) =>
                                                x.SubAccountType == SubAccountType.Pension ||
                                                x.SubAccountType == SubAccountType.Sipp ||
                                                x.SubAccountType == SubAccountType.Npr ||
                                                x.SubAccountType == SubAccountType.Pr
                                        )?.HierarchyId
                                    }
                                    isAddRegularPayment={this.isAddRegularPayment(SubAccountType.Npr)}
                                    onChange={(changes) => {
                                        this.props.onChange(changes);
                                    }}
                                />
                            )}
                            {data.SelectedProducts.length > 0 &&
                                TrueFalseRadio(
                                    "Do you want to add a quote reference?",
                                    "HasQuoteReference",
                                    data.QuoteReference,
                                    (key, value) => {
                                        this.onDataChange(onChange, { [key]: value }, data, "QuoteReference");
                                    },
                                    true,
                                    { cssWrapper: "radio-group rg-150 mb-16" }
                                )}
                            {data?.QuoteReference?.HasQuoteReference && (
                                <>
                                    <TextBoxEditor
                                        cssWrapper="control-size-430 mb-0"
                                        label="Add a quote reference input"
                                        labelGridClasses="sr-only"
                                        maxLength={30}
                                        value={data.QuoteReference.QuoteReferenceDetail}
                                        onChange={(v) =>
                                            this.onDataChange(
                                                onChange,
                                                { QuoteReferenceDetail: v },
                                                data,
                                                "QuoteReference"
                                            )
                                        }
                                        //infoText="(maximum 30 characters)"
                                        required="Please enter quote reference"
                                    />
                                    <span className="text-size-12">(maximum 30 characters)</span>
                                </>
                            )}
                        </>
                    )}
                </PartLoading>    
            </>
        );
    }

    isAddRegularPayment(subAccountType: SubAccountType): boolean {
        if (SubAccountTypeHelper.isOnPlatformPension(subAccountType)) {
            const data = ProductDetailsStore.getProductDetails()?.Products?.find((details) => {
                return (
                    details.ProductType === SubAccountType.Pension ||
                    details.ProductType === SubAccountType.Sipp ||
                    details.ProductType === SubAccountType.Npr
                );
            });
            return data?.RegularPaymentIns?.length <= 0;
        }
        return false;
    }
}
